import { createBrowserHistory } from 'history';
import { getDevsiteFullPath } from 'shared/utils/devsite';

export const browserHistory = createBrowserHistory({ basename: getDevsiteFullPath('') });
